import React, { useEffect, useState } from "react";
import { history } from "../../../../store/configure/configureStore";
import {
  FaPlus,
  FaEllipsisVertical,
  FaEye,
  FaPen,
  FaClockRotateLeft,
} from "react-icons/fa6";
import { MdDelete, MdSearch, MdEditNote } from "react-icons/md";
import { handleRowsPerPage } from "../../../controls/Pagination/Pagination";
import moment from "moment";
import { capitalizeWords } from "../../../../utils/common";
import Tooltip from "react-tooltip";

import { Header, DataTable } from "../../../common";
import {
  ButtonView,
  CardView,
  Input,
  Select,
  ModalView,
} from "../../../controls";
import { NOTIFICATION_ACTIVITY_LOG } from "../../../../navigation/routes";

import "./NotificationManagementStyles.scss";

const NotificationManagementView = ({
  //
  notificationList,
  fields,
  notificationData,
  showModal,
  currentPage,
  rowsPerPage,
  //
  onChangeSearchInput,
  //
  handleInputChange,
  handleClear,
  handleTableRowsChange,
  handleChangePage,
  //
  onClickView,
  onClickDelete,
  handleCloseModal,
  //
  onClickSearch,
  onClickAddNewNotification,
  onClickEditNotification,
  onClickConfirmDelete,
  //
  rowsPerPageDropDownOptions,
  //
  userPermissions,
}) => {
  // console.log("userData", userPermissions);

  const formatDate = (date) => {
    return moment(date)?.format("MM-DD-YYYY");
  };

  const renderTitle = (row) => {
    return (
      <div data-tag="allowRowEvents">
        <span
          data-tag="allowRowEvents"
          data-tip={row.title ? row.title : "-"}
          data-for={`tooltip-title-${row._id}`}
        >
          {capitalizeWords(row?.title) || "-"}
        </span>
        <Tooltip
          id={`tooltip-title-${row._id}`}
          place="top"
          effect="solid"
          type="dark"
          delayShow={500} // Delay in milliseconds
        >
          {row.title ? row.title : "-"}
        </Tooltip>
      </div>
    );
  };

  const renderBody = (row) => {
    return (
      <div data-tag="allowRowEvents">
        <span
          // className="cell-body-styles"
          data-tag="allowRowEvents"
          data-tip={row.body ? row.body : "-"}
          data-for={`tooltip-body-${row._id}`}
        >
          {row.body || "-"}
        </span>
        <Tooltip
          id={`tooltip-body-${row._id}`}
          place="top"
          effect="solid"
          type="dark"
          delayShow={500} // Delay in milliseconds
        >
          {row.body ? row.body : "-"}
          {/* <div className="tooltip-styles">{row.body ? row.body : "-"}</div> */}
        </Tooltip>
      </div>
    );
  };

  const columns = [
    {
      name: "Title",
      width: "20%",
      // selector: (row) => capitalizeWords(row?.title) || "-",
      selector: (row) => renderTitle(row),
    },
    {
      name: "Description",
      width: "25%",
      // selector: (row) => row?.body || "-",
      selector: (row) => renderBody(row),
    },
    {
      name: "Target",
      width: "15%",
      selector: (row) => capitalizeWords(row?.platformId?.label) || "-",
    },
    {
      name: "Created At",
      width: "15%",
      selector: (row) => formatDate(row?.createdAt) || "-",
    },
    {
      name: "Updated At",
      width: "15%",
      selector: (row) => formatDate(row?.updatedAt) || "-",
    },
    {
      name: "Action",
      width: "10%",
      center: true,
      cell: (row, rowIndex) => renderActionMenu(row, rowIndex),
    },
  ];

  // const customStyles = {
  //   cells: {
  //     style: {
  //       width: "100%",
  //       paddingLeft: "8px", // override the cell padding for data cells
  //       paddingRight: "8px",
  //     },
  //   },
  // };

  const customStyles = {
    cells: {
      style: {
        width: "100px", //width set to prevent auto width change
      },
    },
  };

  //--------------------------action UI

  const renderActionMenu = (row) => {
    const menuList = [
      {
        icon: <FaEye size={15} color="#B6C7AA" title="View" />,

        onclick: () => {
          onClickView(row);
          // history?.push(
          //   `/media/notification-management/edit-notification/${row?._id}`
          // );
        },
      },
      // userPermissions?.includes("notification_activity_log") && {
      //   icon: <FaClockRotateLeft size={15} color="#4B70F5" title="logs" />,

      //   onclick: () => {
      //     history?.push(`${NOTIFICATION_ACTIVITY_LOG}/${row?._id}`);
      //   },
      // },
      userPermissions?.includes("update_notification") && {
        icon: <FaPen size={15} color="#4B70F5" title="Edit" />,

        onclick: () => {
          onClickEditNotification(row?._id);
        },
      },
      userPermissions?.includes("delete_notification") && {
        icon: <MdDelete size={15} color="#FF0000" title="Delete" />,

        onclick: () => {
          onClickDelete(row);
        },
      },
    ].filter(Boolean);

    return (
      <div className="action-menu-wrapper d-flex gap-3">
        {menuList.map((item) => {
          return (
            <div className="menu-item" onClick={item?.onclick}>
              {item?.icon}
            </div>
          );
        })}
      </div>
    );
  };

  //--------------------------View modal UI
  const renderViewBody = () => {
    const user = [
      { label: "Title", value: notificationData?.title },
      { label: "Body", value: notificationData?.body },
      {
        label: "Platform",
        value: notificationData?.platformId?.label,
      },
      {
        label: "Created At",
        value: formatDate(notificationData?.createdAt),
      },
      {
        label: "Updated At",
        value: formatDate(notificationData?.updatedAt),
        isLastItem: true,
      },
    ];

    return (
      <div className="body-content-wrapper view-body">
        <div className="content-wrapper">
          {user.map((item, index) => (
            <div key={index}>
              <div
                className={`wrapper ${item.isLastItem && "no-bottom-border"}`}
              >
                <span className="label-wrapper">{item.label}</span>
                <span className="partition">:</span>
                <span
                  className={`value-block ${
                    item.label === "Body" && "body-style"
                  }`}
                >
                  {item.value}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  //--------------------------Delete modal UI
  const renderDeleteBody = () => {
    return (
      <div className="body-content-wrapper delete-body">
        <div>Are you sure you want to delete this notification?</div>
      </div>
    );
  };

  const renderDeleteFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="No"
            styles={"light"}
            size={"medium"}
            onClick={handleCloseModal}
          />
        </div>
        <div className="action-wrapper">
          <ButtonView
            title="Yes"
            styles={"danger"}
            size={"medium"}
            onClick={() => onClickConfirmDelete(notificationData?._id)}
          />
        </div>
      </div>
    );
  };

  // console.log("notificationList Updated", notificationList);
  return (
    <div className="Notification__Management--container">
      <div className="Notification__Management--header-wrapper">
        <div className="title-content">Notification Management</div>
        <div className="action-btn-wrapper">
          {userPermissions?.includes("add_notification") && (
            <ButtonView
              title="Add Notification"
              styles={"secondary"}
              icon={<FaPlus />}
              onClick={onClickAddNewNotification}
            />
          )}
        </div>
      </div>
      <div className="Notification__Management--table-wrapper">
        <div className="controls-wrapper">
          <div className="row-control-wrapper">
            <Select
              value={rowsPerPage}
              placeholder={10}
              options={rowsPerPageDropDownOptions}
              onChange={(val) => {
                handleTableRowsChange(val);
              }}
              isRowCap={true}
            />{" "}
            entries per page
          </div>
          <div className="row-control-wrapper">
            {/* Search:{" "}
            <Input
              value={fields?.searchString}
              onChange={(e) => onChangeSearchInput(e)}
              placeholder={"Type here to search"}
              showClearIcon={fields?.searchString ? true : false}
              handleClear={handleClear}
            />
            <div className="search-action-wrapper">
              <ButtonView
                // title="Search"
                icon={<MdSearch size={20} color="#eca55a" />}
                styles={"secondary"}
                size={"medium btn"}
                onClick={() => onClickSearch()}
              />
            </div> */}
          </div>
        </div>
        <div className="table-content">
          <DataTable
            columns={columns}
            data={notificationList?.docs ? notificationList?.docs : []}
            highlightOnHover={true}
            pointerOnHover={true}
            fixedHeader={true}
            //
            pagination={true}
            paginationServer={true}
            paginationPerPage={notificationList?.limit}
            paginationTotalRows={notificationList?.totalDocs}
            onChangeRowsPerPage={handleTableRowsChange}
            onChangePage={handleChangePage}
            currentPage={currentPage}
            //
            customStyles={customStyles}
          />
        </div>
      </div>
      <ModalView
        show={showModal.showViewModal}
        handleClose={handleCloseModal}
        center={true}
        size={"lg"}
        showCloseIcon={true}
        title={"Notification Details"}
        children={renderViewBody()}
      />
      <ModalView
        show={showModal.showDeleteModal}
        handleClose={handleCloseModal}
        modalHeaderStyles={"delete-modal-header"}
        modalBodyStyles={"delete-modal-body"}
        modalFooterStyles={"delete-modal-footer"}
        center={true}
        showCloseIcon={true}
        title={"Delete"}
        children={renderDeleteBody()}
        footer={renderDeleteFooter()}
      />
    </div>
  );
};

export default NotificationManagementView;
